<template>
  <div class="Warp">
    <van-form @submit="isCompany">
      <van-field
        v-model="company_name"
        name="企业名称"
        label="企业名称"
        placeholder="请输入企业名称"
        :rules="[{ required: true, message: '请输入企业名称' }]"
      />
      <!-- <van-field
        readonly
        clickable
        name="picker1"
        :value="company_type.name"
        label="企业类型"
        placeholder="点击选择企业类型"
        @click="showPicker(1)"
        :rules="[{ required: true, message: '请选择企业类型' }]"
      /> -->
      <!-- <van-field
        readonly
        clickable
        name="picker2"
        :value="consumer.name"
        label="管理员"
        placeholder="点击选择管理员"
        @click="showPicker(2)"
        :rules="[{ required: true, message: '请选择管理员' }]"
      /> -->
   
      <van-field
        name="uploader"
        label="企业Logo"
        :rules="[{ required: true, message: '请上传企业logo' }]"
      >
        <template #input>
          <van-uploader
            v-model="Uploader_logo"
            :after-read="Uploader"
            :max-count="1"
          />
        </template>
      </van-field>
         <van-field
        v-model="mobile"
        name="管理员手机号"
        label="管理员手机号"
        placeholder="请输入管理员手机号"
        :rules="[
          { required: true, message: '' },
          {
            pattern: /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/,
            message: '请输入正确的手机号',
          },
        ]"
      />
      <van-field
        v-model="company_address"
        name="企业地址"
        label="企业地址"
        placeholder="请输入企业地址"
        :rules="[{ required: true, message: '请输入企业名称' }]"
      />
      <van-field
        v-model="company_detail"
        rows="2"
        autosize
        label="企业简介"
        type="textarea"
        maxlength="50"
        placeholder="请输入企业简介"
        show-word-limit
        :rules="[{ required: true, message: '请输入企业简介' }]"
      />
      <van-field
        v-model="principal_name"
        name="联系人姓名"
        label="联系人姓名"
        placeholder="请输入联系人姓名"
        :rules="[{ required: true, message: '请输入联系人姓名' }]"
      />
      <van-field
        v-model="principal_tel"
        name="联系人手机号"
        label="联系人手机号"
        placeholder="请输入联系人手机号"
        :rules="[
          { required: true, message: '' },
          {
            pattern: /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/,
            message: '请输入正确的手机号',
          },
        ]"
      />
      <div style="margin: 16px">
        <van-button round block type="info" native-type="submit"
          >提交</van-button
        >
      </div>
    </van-form>
    <van-popup class="popup" v-model="isShowPicker" position="bottom">
      <form action="/" style="margin-bottom: 10px">
        <van-search
          v-if="this.picker_type != 1"
          v-model="keyWord"
          show-action
          placeholder="请输入搜索关键词"
          @search="onSearch"
          @cancel="onCancel"
        />
      </form>
      <van-picker
        show-toolbar
        :columns="pickerList"
        @confirm="onConfirm"
        @cancel="isShowPicker = false"
        toolbar-position="bottom"
      />
      <div style="height: 30px"></div>
    </van-popup>
  </div>
</template>
<script>
export default {
  data() {
    return {
      consumerList: [],
      companyTypeList: [],
      isShowPicker: false,
      company_name: "",
      picker_type: 0,
      pickerList: [], //弹出框数据
      // consumer: {
      //   name: "",
      //   id: "",
      // },
      mobile: "",
      company_type: {
        name: "",
        id: "",
      },
      Uploader_logo: [],
      company_logo: "",
      company_address: "",
      company_detail: "",
      principal_name: "",
      principal_tel: "",
      keyWord: "",
    };
  },
  mounted() {
    // this.getConsumerList();
    // this.getCompanyType();
  },
  methods: {
    onSearch(val) {
      console.log(val);
      this.keyWord = val;
      this.getConsumerList();
    },
    onCancel() {
      this.keyWord = "";
      this.getConsumerList();
      console.log("取消");
      // asss
    },
    // 获取消费者列表
    getConsumerList() {
      var reqData = {
        keyword: this.keyWord,
      };
      this.$http
        .get("/wechat/api.salesman/consumerList", { params: reqData })
        .then((res1) => {
          var res = res1.body;
          console.log(res);
          let values = [],
            defaultIndex = 1,
            ids = [],
            tels = [];
          res.data.map((v) => {
            if (v.tel == "") {
              v.tel = "--";
            }
            values.push(v.name + "(" + v.tel + ")" || "匿名");
            ids.push(v.cid);
            tels.push(v.tel || "暂无");
          });
          this.consumerList = [];
          this.consumerList.push({
            values,
            defaultIndex,
            ids,
            tels,
          });
          if (this.picker_type != 1 && this.isShowPicker == true) {
            this.pickerList = this.consumerList;
          }
        });
    },
    //获取企业类型
    getCompanyType() {
      this.$http.get("/wechat/api.Salesman/companyType").then((res1) => {
        var res = res1.body;
        console.log(res);
        let values = [],
          defaultIndex = 1,
          ids = [];
        res.data.company_type.map((v) => {
          values.push(v.name);
          ids.push(v.id);
        });

        this.companyTypeList.push({
          values,
          defaultIndex,
          ids,
        });
      });
    },
    // 企业入驻管理员身份判断
    isCompany() {
      this.$http
        .get("/wechat/api.salesman/isCompany", {
          params: { mobile: this.mobile },
        })
        .then((res1) => {
          var res = res1.body;
          if (res.code !== 200) {
            this.$dialog
              .confirm({
                message: res.msg,
              })
              .then(() => {
                this.onSubmit();
              })
              .catch(() => {
                this.$toast.file("已取消入驻申请");
              });
          } else if (res.code == 200) {
            this.onSubmit();
          } else {
            this.$toast.fail("请求操作失败！");
          }
        });
    },
    // 提交入驻信息
    onSubmit() {
      // console.log(values);
      this.$toast.loading({
        forbidClick: true,
        duration:5000,
      });
      var reqData = {
        // consumer_id: this.consumer.id,
        mobile: this.mobile,
        salesman_id: window.localStorage.getItem("salesman_id"),
        company_name: this.company_name,
        // company_type: this.company_type.id,
        company_logo: this.company_logo,
        company_address: this.company_address,
        company_detail: this.company_detail,
        principal_name: this.principal_name,
        principal_tel: this.principal_tel,
      };
      this.$http
        .post("/wechat/api.salesman/applyCompany", reqData, {
          emulateJSON: true,
        })
        .then((res1) => {
          this.$toast.clear();
          var res = res1.body;
          console.log(res);
          if (res.code == 200) {
            this.$toast.success(res.msg);
            this.$router.go(-1);
          } else {
            this.$toast.fail(res.msg);
          }
        });
    },
    // 底部弹框
    showPicker(type) {
      this.picker_type = type;
      this.isShowPicker = true;
      this.keyword = "";
      if (type == 1) {
        console.log("企业类型");
        this.pickerList = this.companyTypeList;
      } else {
        console.log("企业消费者");
        console.log(this.consumerList);
        this.pickerList = this.consumerList;
      }
    },
    // 弹框确定
    onConfirm(v, i) {
      if (this.picker_type == 1) {
        this.company_type.name = v[0];
        this.company_type.id = this.companyTypeList[0].ids[i[0]];
        console.log(this.company_type);
      } else {
        this.consumer.name = v[0];
        this.consumer.id = this.consumerList[0].ids[i[0]];
        console.log(this.consumer);
      }
      console.log(v);
      console.log(i);
      this.isShowPicker = false;
    },
    // 上传图片
    Uploader(file) {
      // var _this = this;
      var imgUrl = this.$store.state.imgUrl;
      console.log(file);
      file.status = "uploading";
      file.message = "上传中...";
      // var reqFile = file.file;
      var formData = new FormData();
      formData.append("file", file.file);
      this.$http
        .post("/wechat/api.common/uploadImg", formData, { emulateJSON: true })
        .then((res1) => {
          // console.log(res);
          var res = res1.body;
          if (res.code == 200) {
            file.status = "done";
            this.company_logo = res.data;
          } else {
            file.status = "failed";
          }
          file.message = res.message;
        });
    },
  },
};
</script>
<style lang="less" scoped>
.popup {
  box-sizing: border-box;
  padding: 20px;
}
</style>